<template>
  <div id="app">
    <div class="headerBox">
      <div class="headerBox-left">
        <a>
          <img src="./assets/logo.png" />
          <span class="appName">语音备忘录</span>
        </a>
      </div>

      <ul>
        <li>
          <a
            class="function-name"
            href="http://downloadapp.appmanager.cn/app/audioeditor.apk"
            >音频剪辑</a
          >
        </li>
        <li class="line">|</li>
        <li>
          <a
            class="function-name"
            href="http://downloadapp.appmanager.cn/app/audioeditor.apk"
            >音频转换</a
          >
        </li>
        <li class="line">|</li>
        <li>
          <a
            class="function-name"
            href="http://downloadapp.appmanager.cn/app/audioeditor.apk"
            >音频合并</a
          >
        </li>
        <li class="line">|</li>
        <li>
          <a
            class="function-name"
            href="http://downloadapp.appmanager.cn/app/audioeditor.apk"
            >音频降噪</a
          >
        </li>
        <li class="line">|</li>
        <li>
          <a
            class="function-name"
            href="http://downloadapp.appmanager.cn/app/audioeditor.apk"
            >音频分离</a
          >
        </li>
      </ul>
    </div>

    <router-view />

    <div class="web-fillings">
      <ul class="fillings">
        <li class="company">上海群港信息技术服务中心&nbsp; &nbsp;</li>
        <li>
          <a href="https://beian.miit.gov.cn/" class="beian" target="_blank"
            >沪ICP备2021015683号-2</a
          >
        </li>
        <li>&nbsp; &nbsp;</li>
        <li>
            <img class="logo_gongan_img" src="./assets/logo_gongan.png" />
        </li>
        <li>&nbsp;</li>
        <li>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011702889266" class="beian" target="_blank"
            >沪公网安备31011702889266号</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  margin-top: 0px;
}

body {
  background-color: #0444ac;
  background-size: cover;
}

.logo_gongan_img {
  width: 20px;
  height: 20px;
}

.web-fillings {
  text-align: end;
  position: fixed;
  text-align: center;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
  color: #5c6b77;
}
.web-fillings ul {
  width: 300px;
  margin: 0 auto;
  display: flex;
  text-align: center;
  flex-direction: row;
  list-style-type: none;
  white-space: nowrap;
}
.web-fillings ul a:hover,
.web-fillings ul a.active {
  color: #347aeb;
}
.beian {
  font-size: 15px;
  color: #fff;
  text-decoration: none;
}
.company {
  font-size: 15px;
  color: #fff;
  margin-bottom: 20px;
}

.headerBox {
  width: 1200px;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  clear: both;
}
.headerBox-left {
  float: left;
  box-sizing: border-box;
}
.headerBox-left img {
  width: 32px;
  height: 32px;
  vertical-align: middle;
  margin-right: 8px;
}
.headerBox-left span {
  font-size: 16px;
  color: #fff;
}

.headerBox ul {
  margin: 0px auto;
  list-style-type: none;
  float: right;
  white-space: nowrap;
}
.headerBox ul li {
  margin: 0px 20px;
  display: inline-block;
}

.headerBox ul li.line {
  margin: 0px;
  color: #fff;
}
.headerBox ul li a {
  font-size: 16px;
  color: #fff;
  text-decoration: none;
}
.headerBox ul li a:hover,
.headerBox ul li a.active {
  color: #347aeb;
}
</style>



// WEBPACK FOOTER //
// src/App.vue